// Group type -> URL prefix for vanity group pages (/therapy-group/<slug> …).
// Mirrors zest_hidden.route_prefix_for_group_type in
// therapi/src/db/migrations/20270111_public_vanity_routes.sql. Adding a group
// type means adding it here AND there (tests/unit/lib/public-routes.spec.ts
// pins the five values).

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();export type GroupTypeValue =
  "THERAPY_GROUP" | "SUPPORT_GROUP" | "WORKSHOP" | "RETREAT" | "PROVIDER_GROUP"

export const GROUP_TYPE_PREFIX: Record<GroupTypeValue, string> = Object.freeze({
  THERAPY_GROUP: "therapy-group",
  SUPPORT_GROUP: "support-group",
  WORKSHOP: "workshop",
  RETREAT: "retreat",
  PROVIDER_GROUP: "clinical-peer-group",
})

export const PROVIDER_PREFIX = "provider"
export const ORGANIZATION_PREFIX = "organization"

export const GROUP_VANITY_PREFIXES: string[] = Object.values(GROUP_TYPE_PREFIX)

export function groupTypePrefix(type: unknown): string | null {
  if (typeof type !== "string") return null
  return (GROUP_TYPE_PREFIX as Record<string, string>)[type] ?? null
}

export function groupTypeForPrefix(prefix: string): GroupTypeValue | null {
  const entry = (
    Object.entries(GROUP_TYPE_PREFIX) as [GroupTypeValue, string][]
  ).find(([, p]) => p === prefix)
  return entry ? entry[0] : null
}
